import { NavBar } from "../navBar/NavBar";

import type { ReactNode } from "react";

export interface WatchViewHeaderProps {
  children?: ReactNode;
}

export function WatchViewHeader({ children }: WatchViewHeaderProps) {
  return (
    <div className="WatchViewHeader">
      <NavBar>{children}</NavBar>
    </div>
  );
}
